export const SAVE_PHONE_OTP = "SAVE_PHONE_OTP"

const savePhoneOtpSuccess = (phone) => ({
  type: SAVE_PHONE_OTP,
  payload: phone,
})

export const savePhoneOtp = (phone) => {
  return (dispatch) => {
    dispatch(savePhoneOtpSuccess(phone))
  }
}
